export const queryKeys = {
    faq: {
        all: ['faq'],
        questions: () => [...queryKeys.faq.all, 'questions'],
    },
    aboutUs: () => ['aboutUs'],
    home: () => ['home'],
    products: () => ['products'],
    subscribes: () => ['subscribes'],
    resources: () => ['resources'],
    header: () => ['header'],
    footer: () => ['footer'],
};

